import React from 'react'
import { IonIcon, IonItem, IonLabel, IonList } from '@ionic/react'
import { checkmark } from 'ionicons/icons'
import { IOption } from '../../../../../common/common.types'
import './ReassignCrewMember.content.css'

interface IReassignCrewMemberContentProps {
  crewOptions: IOption[]
  selectedIndex: number | null
  onSelectIndex: (index: number) => void
}

const ReassignCrewMemberContent: React.FC<IReassignCrewMemberContentProps> = ({
  crewOptions,
  selectedIndex,
  onSelectIndex,
}) => (
  <IonList lines='none' className='qa-addendum-reassign-list'>
    {crewOptions.map((option, index) => {
      const isSelected = index === selectedIndex
      return (
        <IonItem
          key={`${String(option.id)}-${index}`}
          lines='none'
          button
          detail={false}
          className='qa-addendum-reassign-option'
          onClick={() => onSelectIndex(index)}>
          <span className='qa-addendum-reassign-check-slot' aria-hidden={!isSelected}>
            {isSelected && <IonIcon size='small' icon={checkmark} color='primary-alt' />}
          </span>
          <IonLabel>{option.name}</IonLabel>
        </IonItem>
      )
    })}
  </IonList>
)

export default React.memo(ReassignCrewMemberContent)
